export default defineNuxtRouteMiddleware(to => {
  const { isNewFreePlan } = useUserPlanInfo()
  if (isNewFreePlan.value && to.name === 'upload') {
    return navigateTo('/')
  }
})
